var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.767,
    height: 20.369,
    viewBox: "0 0 20.767 20.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4A87F8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.944,6.07c-5.726,0-10.384,4.32-10.384,9.645a9.217,9.217,0,0,0,2.883,6.676l-.562,3.366a.593.593,0,0,0,.872.609L11.867,24.6a11,11,0,0,0,4.076.785c5.726,0,10.384-4.32,10.384-9.653S21.669,6.07,15.944,6.07Zm5.965,9.4L21.442,19A1.771,1.771,0,0,1,19.69,20.53H16.556a5.691,5.691,0,0,1-1.983-.353l-1.064-.389a.554.554,0,0,1-.393.145H10.548a.589.589,0,0,1-.589-.589V14.117a.589.589,0,0,1,.589-.589h2.58a.577.577,0,0,1,.393.145,2.859,2.859,0,0,0,1.363-.856,3.605,3.605,0,0,0,.192-1.7c0-.216-.02-.432-.02-.656a.974.974,0,0,1,.573-.88,2.019,2.019,0,0,1,2.03.393,3.166,3.166,0,0,1,.982,3.055h1.127a2.168,2.168,0,0,1,2.14,2.443Zm-10.772-.785h1.4v4.045h-1.4Zm9.37-.173a.97.97,0,0,1,.232.785l-.483,3.534a.589.589,0,0,1-.585.507H16.556a4.552,4.552,0,0,1-1.571-.279l-1.268-.448V14.855a3.908,3.908,0,0,0,2.227-1.539,4.611,4.611,0,0,0,.3-2.25q0-.224,0-.448a1.049,1.049,0,0,1,.672.247c.342.271.856.97.459,2.6a.585.585,0,0,0,.569.727h1.838a.97.97,0,0,1,.723.338Z",
    transform: "translate(-5.56 -6.07)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackActive);
export default __webpack_public_path__ + "static/media/feedback_active.e9b800273a730be1d84d8941fc5cac52.svg";
export { ForwardRef as ReactComponent };